import type { DataType, Product } from "@/graphql/codegen/graphql"

export enum ProductQualityTabPathname {
  Templates = "templates",
  Results = "results",
}

export type ProductQualityInstructions = Pick<
  Product,
  | "isOperatorActionRequired"
  | "postTestNotes"
  | "preTestNotes"
  | "printExpirationToAkrochemCoa"
  | "printMfgDatesToAkrochemCoa"
  | "printPostTestNotesToAkrochemCoa"
  | "printPreTestNotesToAkrochemCoa"
  | "operatorActionDescription"
>

export interface AssociatedTestTemplateFormPayload {
  equalToValue?: string | null
  maximumValue?: string | null
  minimumValue?: string | null
  dataType?: DataType | null
  significantFigures?: number | null
  printToAkrochem: boolean
}
